<ng-container *transloco="let t; read: 'calculator_result.save_power_plant'">
  <psc-button
   *ngIf="[UserRole.ROLE_PERSONAL, UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS] | userHasRole"
    [width]="325"
    [label]="t('button_title')"
    [disabled]="saveDisabled"
    (buttonClicked)="showDialog = true">
  </psc-button>
  <psc-dialog
    *ngIf="showDialog"
    [title]="t('dialog_title')"
    (closeClicked)="showDialog = false">
    <psc-save-power-plant-form
      (plantSaved)="onSavedPlant($event)"
      (canceled)="showDialog = false"
      [calculatorResultWrapper]="resultWrapper"></psc-save-power-plant-form>
  </psc-dialog>
</ng-container>
